import React, { useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function KarsanStockVehiclesReportTable({
    items,
    totalCount,
    loading,
    lazyParams,
    onPage,
    sortField,
    sortOrder,
    onSortChange
}) {
    const { th } = useLanguage();
    const dataTableRef = useRef(null);

    const rows = Array.isArray(items)
        ? items.map((item, index) => ({ ...item, _rowId: `${lazyParams.first}-${index}` }))
        : [];

    return (
        <DataTable
            value={rows}
            dataKey="_rowId"
            lazy
            paginator
            rows={lazyParams.rows}
            first={lazyParams.first}
            totalRecords={totalCount}
            onPage={onPage}
            loading={loading}
            emptyMessage={th('common.noRecords')}
            rowsPerPageOptions={[10, 25, 50]}
            showGridlines
            tableStyle={{ minWidth: '50rem' }}
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSortChange}
            ref={dataTableRef}
        >
            <Column sortable field="brand" header={th('karsanStockVehiclesReport.columns.brand')} style={{ minWidth: '130px' }} />
            <Column sortable field="model" header={th('karsanStockVehiclesReport.columns.model')} style={{ minWidth: '130px' }} />
            <Column sortable field="maktx" header={th('karsanStockVehiclesReport.columns.maktx')} style={{ minWidth: '180px' }} />
            <Column sortable field="matnr" header={th('karsanStockVehiclesReport.columns.matnr')} style={{ minWidth: '180px' }} />
            <Column sortable field="sasiNo" header={th('karsanStockVehiclesReport.columns.sasiNo')} style={{ minWidth: '200px' }} />
        </DataTable>
    );
}
